module.exports = __webpack_public_path__ + "static/media/St Georges Road Alcove Unit (11).b7c68f30.jpg";